import * as React from 'react';
import { AddressType, AddressVariants } from '../../models/Address';
import './style.scss';
import Text from '../Text';
import classNames from 'classnames';
import Link from '../Link';

interface Props {
  addresses: AddressType[];
  dark?: boolean;
  align?: 'center';
  isLegacy?: boolean;
}

const Address: React.SFC<Props> = ({
  addresses,
  dark,
  align,
  isLegacy = true,
}) => {
  const classPrefix = isLegacy ? 'address-legacy' : 'address';

  return (
    <div
      className={classNames({
        [`${classPrefix}__wrapper`]: align === 'center',
      })}
    >
      {addresses?.map((item: AddressType, index: number) => {
        const isLocation = item.variant === AddressVariants.Location;
        return (
          <div
            key={`${item.title}-${item.address}-${isLocation ? item.cityZip : item.link}-${index}`}
            className={classNames(classPrefix, {
              [`${classPrefix}--lined`]: align === 'center',
            })}
            itemProp={isLocation ? 'address' : 'email'}
            itemScope
            itemType={
              isLocation
                ? 'http://schema.org/PostalAddress'
                : 'http://schema.org/ContactPoint'
            }
          >
            <Text
              type="label"
              weight="demi-bold"
              color={dark ? 'dark' : 'light'}
              className={classNames(
                `${classPrefix}__line`,
                'h5',
                `${classPrefix}__line--header`,
                {
                  [`${classPrefix}__line--centered`]: align === 'center',
                }
              )}
            >
              {item.title}
            </Text>
            {isLocation ? (
              <>
                <Text
                  type="label"
                  weight="medium"
                  color={dark ? 'dark' : 'light'}
                  dim={dark ? 'dark-40' : '40'}
                  className={classNames(`${classPrefix}__line`, 'h6', {
                    [`${classPrefix}__line--centered`]: align === 'center',
                    'p-updated': !isLegacy,
                  })}
                  itemProp="streetAddress"
                >
                  {item.addressTop ? (
                    <>
                      {item.addressTop}
                      <br />
                    </>
                  ) : null}
                  {item.address}
                </Text>
                <Text
                  type="label"
                  weight="medium"
                  color={dark ? 'dark' : 'light'}
                  dim={dark ? 'dark-40' : '40'}
                  className={classNames(`${classPrefix}__line`, 'h6', {
                    [`${classPrefix}__line--centered`]: align === 'center',
                    'p-updated': !isLegacy,
                  })}
                  itemProp="postalCode"
                >
                  {item.cityZip}
                </Text>
              </>
            ) : (
              <Link href={`mailto:${item.link}`}>
                <Text
                  type="label"
                  weight="medium"
                  color={dark ? 'dark' : 'light'}
                  dim={dark ? 'dark-40' : '40'}
                  className={classNames(`${classPrefix}__line`, 'h6', {
                    [`${classPrefix}__line--centered`]: align === 'center',
                    'p-updated': !isLegacy,
                  })}
                  itemProp="email"
                >
                  {item.address}
                </Text>
              </Link>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Address;
